import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ProductDetail from "@/pages/ProductDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App bg-oed-base text-white">
      <Toaster theme="dark" position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
                <Landing />
              </ReactLenis>
            }
          />
          <Route
            path="/products/:key"
            element={
              <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
                <ProductDetail />
              </ReactLenis>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
